export const GIVES_BACK_STORAGE_KEY = "equinox_gives_back_update_token";

export const givesBackHero = {
  eyebrow: "Business with a purpose",
  title: "Your Growth. A Kinder World.",
  description:
    "At Equinox Marketing Agency, we believe business can do more. We dedicate 1% of our eligible revenue from every invoice to causes that create a positive impact — because growth should create opportunities beyond business.",
  heroImage:
    "https://images.unsplash.com/photo-1722432504364-967b623810dd?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzMzN8MHwxfHNlYXJjaHw0fHxzdHJlZXQlMjBkb2clMjB2ZXRlcmluYXJpYW4lMjBjYXJlJTIwSW5kaWF8ZW58MHx8fHwxNzkxNzE5MzE3fDA&ixlib=rb-4.1.0&q=85",
  heroAlt: "A rescued Indian street dog receiving calm, caring attention from a local caregiver.",
  trustIndicators: ["1% from Every Invoice", "Real-World Impact", "Transparent Updates"],
};

export const givesBackCauses = [
  {
    id: "educate_child",
    emoji: "📚",
    title: "Educate a Child",
    description:
      "Help provide books, notebooks, stationery, and essential learning materials to children in need.",
    image:
      "https://images.unsplash.com/photo-1623303366639-0e330d7c3d9f?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2NzF8MHwxfHNlYXJjaHwyfHxJbmRpYW4lMjBzY2hvb2wlMjBjaGlsZCUyMGJvb2tzJTIwZWR1Y2F0aW9ufGVufDB8fHx8MTc5MTcxOTMwOHww&ixlib=rb-4.1.0&q=85",
    alt: "An Indian schoolchild holding books and learning materials with classmates in the background.",
  },
  {
    id: "feed_someone",
    emoji: "🍲",
    title: "Feed Someone",
    description:
      "Help provide nutritious meals to children and other people experiencing hardship.",
    image:
      "https://images.unsplash.com/photo-1677128912094-36d988ce198b?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjY2NzV8MHwxfHNlYXJjaHwxfHx2b2x1bnRlZXIlMjBzZXJ2aW5nJTIwbWVhbCUyMEluZGlhfGVufDB8fHx8MTc5MTcxOTMwOHww&ixlib=rb-4.1.0&q=85",
    alt: "Volunteers serving warm meals during a community food distribution drive.",
  },
  {
    id: "feed_stray",
    emoji: "🐕",
    title: "Feed a Stray",
    description:
      "Support street-dog feeding and basic animal care through responsible local caregivers.",
    image:
      "https://images.unsplash.com/photo-1674802401345-4e6ec9fc2146?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA2MjJ8MHwxfHNlYXJjaHwxfHxmZWVkaW5nJTIwc3RyYXklMjBkb2clMjB2b2x1bnRlZXIlMjBJbmRpYXxlbnwwfHx8fDE3OTE3MTkzODR8MA&ixlib=rb-4.1.0&q=85",
    alt: "A volunteer gently feeding Indian street dogs in an outdoor setting.",
  },
  {
    id: "care_for_cow",
    emoji: "🐄",
    title: "Care for a Cow",
    description:
      "Support fodder and essential care through trustworthy local caregivers or gaushalas.",
    image:
      "https://images.unsplash.com/photo-1646946121093-443fd06b4312?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2NzR8MHwxfHNlYXJjaHwyfHxjb3clMjBlYXRpbmclMjBncmVlbiUyMGZvZGRlciUyMEluZGlhfGVufDB8fHx8MTc5MTcxOTMwOHww&ixlib=rb-4.1.0&q=85",
    alt: "A cow calmly eating fresh green fodder beside a vivid village wall.",
  },
  {
    id: "plant_tree",
    emoji: "🌱",
    title: "Plant a Tree",
    description:
      "Support saplings, responsible planting initiatives, and ongoing plant care.",
    image:
      "https://images.unsplash.com/photo-1590682680695-43b964a3ae17?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1NzR8MHwxfHNlYXJjaHwyfHxwbGFudGluZyUyMHlvdW5nJTIwc2FwbGluZyUyMHZvbHVudGVlcnxlbnwwfHx8fDE3OTE3MTkzMDh8MA&ixlib=rb-4.1.0&q=85",
    alt: "Hands planting a young green sapling into healthy soil.",
  },
];

export const givesBackProcessSteps = [
  {
    title: "Every Invoice",
    body:
      "Equinox Marketing Agency allocates 1% of eligible revenue associated with every invoice.",
  },
  {
    title: "You Choose a Cause",
    body:
      "Clients can select the cause they would like their contribution to support through the website or another available digital channel.",
  },
  {
    title: "We Take Action",
    body:
      "Depending on the selected cause and allocated budget, we purchase educational supplies, arrange meals, provide dog food, contribute fodder, or support tree planting and care.",
  },
  {
    title: "We Share an Update",
    body:
      "We provide a digital update about completed activities, with photographs and supporting evidence where available.",
  },
];

export const givesBackPolicyNotes = [
  "The 1% contribution is funded by Equinox Marketing Agency.",
  "It is not an additional charge to the client.",
  "The contribution is calculated on eligible revenue excluding GST, under a clearly documented company policy.",
  "Actual goods and services depend on the allocated budget and local costs.",
  "Client-selected causes guide the allocation associated with the relevant engagement.",
  "If no cause is selected, Equinox Marketing Agency will allocate the contribution according to its internal Gives Back policy and current impact priorities.",
  "Optional additional client contributions may be introduced in a future phase. This version does not add mandatory donations or extra client charges.",
];

export const givesBackIllustrativeExamples = [
  { amount: "₹50", title: "Educational supplies", description: "May help purchase educational supplies." },
  { amount: "₹100", title: "A meal", description: "May help fund a meal." },
  { amount: "₹200", title: "Food for street dogs", description: "May help purchase food for street dogs." },
  { amount: "₹300", title: "Fodder for a cow", description: "May help purchase fodder for a cow." },
  { amount: "₹150", title: "A sapling", description: "May help fund a sapling and its initial care." },
];

export const givesBackFaqs = [
  {
    question: "What is Equinox Gives Back?",
    answer:
      "Equinox Gives Back is Equinox Marketing Agency’s initiative to dedicate 1% of eligible revenue from every invoice to positive social and environmental causes.",
  },
  {
    question: "How is the 1% calculated?",
    answer:
      "The 1% is calculated on eligible revenue excluding GST, according to Equinox Marketing Agency’s published contribution policy.",
  },
  {
    question: "Does this increase my invoice amount?",
    answer:
      "No. The contribution is funded by Equinox Marketing Agency and is not added to the client’s bill.",
  },
  {
    question: "Can I change my selected cause?",
    answer:
      "Yes. Clients can update their preference through an appropriate digital process when a reliable engagement or session reference is available.",
  },
  {
    question: "What happens if I don’t select a cause?",
    answer:
      "If no cause is selected, Equinox Marketing Agency will allocate the contribution according to its internal Gives Back policy and current impact priorities. No client-selected allocation is claimed unless a selection is recorded.",
  },
  {
    question: "Will I receive an impact update?",
    answer:
      "Equinox aims to share updates about completed activities and supporting evidence where available.",
  },
  {
    question: "How do you verify contributions?",
    answer:
      "Contribution records, receipts, and available evidence are maintained according to the initiative’s internal processes.",
  },
  {
    question: "Can I make an additional contribution?",
    answer:
      "Optional client contributions may be introduced in a future phase and are not required for participation in the current initiative.",
  },
];

export const givesBackLaunchStateMessage =
  "We are building our impact programme. Verified contribution updates will appear here as activities are completed.";
